module.exports = __webpack_public_path__ + "assets/img/1.d6eb77c6.png";